// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__3xw2y","title":"ClientReferral_title__2hlMz","itemText":"ClientReferral_itemText__1NUVp"};